import { useCallback, useEffect, useRef } from 'react'

// Keeps the screen awake while the voice session is active.
// Supported on Chrome/Edge/Safari 16.4+. Silently no-ops where unsupported.
export function useWakeLock() {
  const sentinelRef = useRef(null)

  const release = useCallback(async () => {
    if (sentinelRef.current) {
      try {
        await sentinelRef.current.release()
      } catch {
        /* ignore */
      }
      sentinelRef.current = null
    }
  }, [])

  const acquire = useCallback(async () => {
    if (!('wakeLock' in navigator)) return false
    try {
      sentinelRef.current = await navigator.wakeLock.request('screen')
      // Browser may auto-release on tab hide; reacquire when visible again.
      sentinelRef.current.addEventListener('release', () => {
        sentinelRef.current = null
      })
      return true
    } catch {
      return false
    }
  }, [])

  useEffect(() => {
    return () => {
      void release()
    }
  }, [release])

  return { acquire, release }
}
